import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from '../../axios/instance';

export const fetchContactTypes = createAsyncThunk('contactType/fetchAll', async () => {
  const res = await API.get('contact/contactType');
  return res.data;
});

export const createContactType = createAsyncThunk('contactType/create', async (payload) => {
  const res = await API.post('contact/contactType/create-contact-type', payload);
  return res.data?.result || res.data;
});

export const updateContactType = createAsyncThunk('contactType/update', async ({ id, data }) => {
  const res = await API.put(`contact/contactType/${id}`, data);
  return res.data?.result || res.data;
});

export const deleteContactType = createAsyncThunk('contactType/delete', async (id) => {
  await API.delete(`contact/contactType/${id}`);
  return id;
});

